import { T } from 'gt-react';

export type StagedView = 'before' | 'after';

/**
 * Segmented Before/After control for the change-set review views: "Before"
 * shows the live ingest values, "After" the values with staged (and unsaved)
 * edits applied — same table either way, only the cell values swap.
 */
export function BeforeAfterToggle({
  value,
  onChange,
}: {
  value: StagedView;
  onChange: (view: StagedView) => void;
}) {
  return (
    <div className="inline-flex w-fit rounded-md border overflow-hidden text-xs">
      <button
        type="button"
        aria-pressed={value === 'before'}
        className={`px-3 py-1 transition-colors${value === 'before' ? ' bg-primary text-primary-foreground' : ' bg-background text-foreground hover:bg-muted'}`}
        onClick={() => onChange('before')}
      >
        <T context="change-set review toggle: original (live) values">Before</T>
      </button>
      <button
        type="button"
        aria-pressed={value === 'after'}
        className={`px-3 py-1 border-l transition-colors${value === 'after' ? ' bg-primary text-primary-foreground' : ' bg-background text-foreground hover:bg-muted'}`}
        onClick={() => onChange('after')}
      >
        <T context="change-set review toggle: values with staged edits applied">
          After
        </T>
      </button>
    </div>
  );
}
